export const API_BASE_URL =
  'https://pebblehrm.annaiarulpublicschool.com/aaps-api/api';

export const APP_BASE_URL =
  'https://pebblehrm.annaiarulpublicschool.com';

export const MOBILE_API_BASE_URL =
  'https://pebblehrm.annaiarulpublicschool.com/annaiapi';
// export const API_BASE_URL = 'http://192.168.1.26:8000/api';
// export const APP_BASE_URL = 'http://192.168.1.26:8000/api';
// export const MOBILE_API_BASE_URL = 'https://pebblehrm.annaiarulhospital.com/annaiapi';


